import React from 'react';
import { Routes, Route } from 'react-router-dom';
import WipeAway from './WipeAway';
import BidetWay from './BidetWay';

const Main = () => {
  return (
    <Routes>
      <Route path="/" element={<WipeAway />} />
      <Route path="/bidetway" element={<BidetWay />} />
    </Routes>
  );
};

export default Main;